// extracted by mini-css-extract-plugin
export default {"modal":"Hha-z","header":"Iha-z","fields":"Jha-z","error":"Kha-z","disabled":"Lha-z","reminderMsg":"Mha-z","errorMsg":"Nha-z","footer":"Oha-z"};